export default "__VITE_ASSET__45f5206b__"